import React, { Component } from 'react'
import Select from 'react-select'

class Status extends Component {
    constructor() {
        super()
        this.state = {
            StatusList:[ {"label":"ACTIVE","value":"ACTIVE"},{"label":"IN ACTIVE","value":"IN ACTIVE"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }
    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.StatusList}
                placeholder="Select Status"
                onChange={(e) => { (e) ? this.props.statusChange(e) : this.props.statusChange([])}}
                />
            </div>
        )
    }
}

export default Status


// WEBPACK FOOTER //
// ./src/common/DropDowns/Status.js